var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-start relative"},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('loader-line',{attrs:{"loading":_vm.loading}})],1):_vm._e(),_c('div',{staticClass:"detail-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("detail-row-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }